import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class UndoManagementGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		
		var undoGrid = this;
		setTimeout(function(){
			undoGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var undoGrid = this;
		var DELETED_DATA_ENTITY = 'DeletedDataBatch';
		
		var updateActionButtons = function() {
			var selected = grid.selectedItems || [];
			var hasSelection = selected.length > 0;
			ElementUtil.query(toolbar, 'view').disabled = selected.length !== 1;
			ElementUtil.query(toolbar, 'undo').disabled = !hasSelection;
			ElementUtil.query(toolbar, 'partialrestore').disabled = selected.length !== 1
					|| !selected[0].entityClass
					|| selected[0].entityClass.indexOf(DELETED_DATA_ENTITY) < 0;
			ElementUtil.query(toolbar, 'delete').disabled = !hasSelection;
		};

		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
			'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filtercompany',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;' + (undoGrid.user ? 'display: none;' : ''),
					label: 'Company',
					'item-value-path': 'code',
					'item-label-path': 'description',				
					postinit: function(combo) {
						Service.getCompanyService().getCompaniesLookup().then(function(data){
							combo.items = data;
						});
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							actionRefresh();
						}
					}					
				},
				{
					tag: 'vaadin-combo-box',
					itemid: 'filterfield',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					style: 'width: 180px;',
					label: 'Filter By',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					value: 'description',
					postinit: function(combo) {
						combo.items = [
							{
								code: 'description',
								description: 'Description'
							},
							{
								code: 'entityClass',
								description: 'Entity Class'
							}
						];
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'vaadin-text-field',
					itemid: 'filtervalue',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Filter Value',
					style: 'width: 220px;',
					placeholder: 'Contains search',
					listeners: {
						input: {
							fn: function() {
								actionRefresh();
							},
							buffer: 2000
						},
						change: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'vaadin-date-picker',
					itemid: 'filtermarkedstart',
					'class': 'spacer-toolbar-item',
					label: 'Marked From',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.startCurrentMonth());
					}(),
					listeners: {
						change: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'vaadin-date-picker',
					itemid: 'filtermarkedend',
					'class': 'spacer-toolbar-item',
					label: 'Marked To',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.endCurrentMonth());
					}(),
					listeners: {
						change: function() {
							actionRefresh();
						}
					}
				}
			]
		});

		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'view',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					disabled: true,					
					permissions: ['ADMIN_UNDO_MANAGEMENT:READ'],
					children:[
						ElementUtil.makeIcon('lumo:eye', ' View Record')						
					],
					listeners: {
						click: function() {
							actionShowRecord(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'undo',
					'class': 'spacer-toolbar-item',					
					disabled: true,					
					permissions: ['ADMIN_UNDO_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:arrow-backward', ' Undo')						
					],
					listeners: {
						click: function() {
							actionUndoSelected();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'partialrestore',
					'class': 'spacer-toolbar-item',
					disabled: true,
					permissions: ['ADMIN_UNDO_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:options', ' Partial Restore')
					],
					listeners: {
						click: function() {
							actionPartialRestore(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'delete',
					theme: 'error primary',					
					permissions: ['ADMIN_UNDO_MANAGEMENT:DELETE'],
					'class': 'spacer-toolbar-item',
					style: 'float: right;',				
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionDeleteSelected();
						}
					}
				}			
			]
		});

		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [
				{
					tag: 'vaadin-grid-selection-column',
					'auto-select': true,
					flexGrow: 0
				},
				{						
					path: 'companyName',
					header: 'Company Name',					
					width: '7em'
				},
				{						
					path: 'description',
					header: 'Description',				
					'text-align': 'left',
					width: '18em'
				},					
				{						
					path: 'entityClass',
					header: 'Entity Class',					
					width: '10em'
				},
				{
					path: 'markedForDeletionDts',
					header: 'Marked Date',					
					width: '11em',					
					renderer: function(root, column, rowData) {						
						root.innerHTML = TimeUtil.formatDateStandard(rowData.item.markedForDeletionDts);						
					}
				},
				{						
					path: 'daysRemaining',
					header: 'Days before Expiring',			
					width: '7em',
					'text-align': 'center',
					renderer: function(root, column, rowData) {	
						if (rowData.item.daysRemaining <= 3 ) {
							root.style.backgroundColor = '#ffbdbd';
						} else if (rowData.item.daysRemaining > 3 && rowData.item.daysRemaining < 7) {
							root.style.backgroundColor = '#68680e';
						} else {
							root.style.backgroundColor = '';
						}
						if (rowData.item.daysRemaining === -1) {
							
						} else {
							root.innerHTML = rowData.item.daysRemaining;						
						}
					}
				}
			],
			listeners: {
				'selected-items-changed': function() {
					updateActionButtons();
				},
				'active-item-changed': function(event) {
					const item = event.detail.value;
					if (item && !(grid.selectedItems || []).includes(item)) {
						grid.selectedItems = (grid.selectedItems || []).concat([item]);
					}
					updateActionButtons();
				}
			}
		});	
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function(companyId) {
						var markedStartValue = ElementUtil.query(toolbarFilter, 'filtermarkedstart').value;
						var markedEndValue = ElementUtil.query(toolbarFilter, 'filtermarkedend').value;
						undoGrid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'markedForDeletionDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'DESC',
							companyId: companyId,
							filterField: ElementUtil.query(toolbarFilter, 'filterfield').value || 'description',
							filterValue: ElementUtil.query(toolbarFilter, 'filtervalue').value,
							markedStartDts: markedStartValue ? TimeUtil.startOfDayCompanyTime(markedStartValue) : null,
							markedEndDts: markedEndValue ? TimeUtil.endOfDayCompanyTime(markedEndValue) : null
						};

						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;
							grid.selectedItems = [];
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();
							updateActionButtons();
						};

						DataManagementService.getUndoService().getUndoRecords(undoGrid.currentFilter)
								.then(function(records){							
							successHandler(records);
						});	
					};					
										
					loadData(ElementUtil.query(toolbarFilter, 'filtercompany').value);
														
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'undo-management',
			onDetail: function() {
				ExportUtil.exportGridItemsAsCsv(grid.items, 'undo-management.csv');
			}
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footer.footerContainer
			]
		});		
		undoGrid.append(flexLayout);		
				
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};
		
		var actionShowRecord = function(record) {
			var detailWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Record Details',
				icon: 'vaadin:modal-list',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						detailWin.show();
						
						var detailTable = ElementUtil.create({
							tag: 'dl-detail-table',
							itemid: 'detailtable',
							slot: 'primary'
						});						
						
						
						
						var layout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [							
								detailTable
							]
						});	
						
						detailWin.addToContentElement(layout);
						
						var loadMask = detailTable.showLoading();
						DataManagementService.getUndoService().getUndoEntity(record.undoId).then(function(entity) {
							loadMask.remove();

							var formatDetailValue = function(key, value) {
								if (value == null || value === '') {
									return 'N/A';
								}
								var keyLooksLikeDate = typeof key === 'string'
										&& (key.endsWith('Dts') || key.endsWith('Date') || key === 'markedForDeletionDts');
								if (keyLooksLikeDate || TimeUtil.looksLikeDateTimeValue(value)) {
									return TimeUtil.formatDateCompanyAndSystem(value);
								}
								return value;
							};

							var formatDescriptionForDetail = function(description, entityRecord) {
								if (!description) {
									return 'N/A';
								}
								if (!entityRecord || !entityRecord.startDts || !entityRecord.endDts) {
									return description;
								}
								var descriptionWithoutDates = String(description).replace(
										/,\s*\d{2}\/\d{2}\/\d{4}[\s\S]*$/,
										'');
								return descriptionWithoutDates
										+ ', '
										+ TimeUtil.formatDateCompanyAndSystem(entityRecord.startDts)
										+ ' to '
										+ TimeUtil.formatDateCompanyAndSystem(entityRecord.endDts);
							};

							var data = [];
							if (record.description) {
								data.push({
									key: 'description',
									value: formatDescriptionForDetail(record.description, entity)
								});
							}
							if (record.markedForDeletionDts) {
								data.push({
									key: 'markedForDeletionDts',
									value: TimeUtil.formatDateCompanyAndSystem(record.markedForDeletionDts)
								});
							}
							if (record.entityClass) {
								data.push({
									key: 'entityClass',
									value: record.entityClass
								});
							}
							for (var key in entity) {
								if (key === 'description' || key === 'markedForDeletionDts' || key === 'entityClass') {
									continue;
								}
								data.push({
									key: key,
									value: formatDetailValue(key, entity[key])
								});
							}

							detailTable.updateDetails(data);
						});
												
					}
				}
			});		
			
		};

		var selectedUndoIds = function() {
			return (grid.selectedItems || []).map(function(item) {
				return item.undoId;
			});
		};
		
		var actionUndoSelected = function() {
			var selected = grid.selectedItems || [];
			if (selected.length === 0) {
				return;
			}
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Undo',
				message: 'Are you sure you want to undo <b>' + selected.length + '</b> selected record(s)?<br>'
						+ 'Deleted operational data restores as a background task and respects data locks. '
						+ 'If some records are locked, the undo entry stays so you can unlock and retry; '
						+ 'deleting the undo entry permanently removes any remaining soft-deleted data.',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Undoing...');
							var undoIds = selectedUndoIds();
							var request = undoIds.length === 1
									? DataManagementService.getUndoService().undoEntity(undoIds[0])
									: DataManagementService.getUndoService().bulkUndo(undoIds);
							request.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Undo submitted for ' + undoIds.length + ' record(s)', {
									theme: 'success'
								});
								actionRefresh();
							});
						}
					},
					{
						text: 'No'
					}
				]
			});
		};

		var actionPartialRestore = function(record) {
			if (!record) {
				return;
			}
			var dialog = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Partial Restore',
				icon: 'vaadin:options',
				width: .85,
				height: .8,
				properties: {
					fitContent: true
				},
				listeners: {
					ready: function() {
						dialog.show();

						var selectedForRestore = [];
						var unitSelectionMinHeight = 'min(55vh, 480px)';

						var info = ElementUtil.create({
							tag: 'div',
							style: 'padding: 4px 8px;',
							trustedInnerHTML: true,
							innerHTML: '<div style="margin-bottom: 6px;">' + (record.description || '') + '</div>'
									+ '<div>Data locks apply; locked periods are skipped.</div>'
						});

						var optionsToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'vaadin-checkbox',
									itemid: 'allunits',
									'class': 'spacer-toolbar-item',
									label: 'All units',
									checked: true,
									listeners: {
										change: function() {
											actionToggleAllUnits();
										}
									}
								},
								{
									tag: 'vaadin-checkbox',
									itemid: 'manualonly',
									'class': 'spacer-toolbar-item',
									label: 'Restore manually entered records only'
								}
							]
						});

						var availableFilterToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'vaadin-combo-box',
									itemid: 'filterfield',
									'class': 'spacer-toolbar-item',
									'keep-open': true,
									style: 'width: 160px;',
									label: 'Filter By',
									'item-value-path': 'code',
									'item-label-path': 'description',
									value: 'unitRefNo',
									postinit: function(combo) {
										combo.items = [
											{code: 'unitRefNo', description: 'Unit Ref No'},
											{code: 'unitId', description: 'Unit Id'}
										];
									},
									listeners: {
										change: function() {
											actionLoadAvailable();
										}
									}
								},
								{
									tag: 'vaadin-text-field',
									itemid: 'filtervalue',
									'class': 'spacer-toolbar-item',
									'keep-open': true,
									label: 'Filter Value',
									listeners: {
										input: {
											fn: function() {
												actionLoadAvailable();
											},
											buffer: 500
										},
										change: function() {
											actionLoadAvailable();
										}
									}
								}
							]
						});

						var availableTitle = ElementUtil.create({
							tag: 'div',
							slot: 'toolbar',
							children: [
								{
									tag: 'dl-section-title',
									title: 'Affected Units',
									style: 'margin-top: 8px;'
								},
								availableFilterToolbar
							]
						});

						var availableGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							'rows-draggable': true,
							'drop-mode': 'on-grid',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true
							},
							children: [
								{
									tag: 'vaadin-grid-selection-column',
									'auto-select': true,
									'auto-width': true
								},
								{
									path: 'referenceType',
									header: 'Type',
									width: '6em'
								},
								{
									path: 'unitRefNo',
									header: 'Unit Ref No',
									width: '9em'
								},
								{
									path: 'unitId',
									header: 'Unit Id',
									width: '9em'
								}
							],
							listeners: {
								'active-item-changed': function(event) {
									const item = event.detail.value;
									availableGrid.selectedItems = item ? [item] : [];
								},
								'grid-dragstart': function(event) {
									availableGrid.draggedItems = event.detail.draggedItems;
								},
								'grid-dragend': function() {
									delete availableGrid.draggedItems;
								},
								'grid-drop': function() {
									const dragged = includeGrid.draggedItems;
									if (!dragged) {
										return;
									}
									actionRemoveUnits(dragged);
								}
							}
						});

						var availablePagingToolbar = ElementUtil.create({
							tag: 'dl-paging-toolbar',
							slot: 'footer',
							pageSize: 50,
							postinit: function(element) {
								element.grid = availableGrid;
								element.loader = function(backingGrid, pageNumber, pagingToolbar) {
									var pageRange = pagingToolbar.pullRange();
									var loadMask = availableGrid.showLoading();
									var filter = {
										offset: pageRange.offset,
										max: pageRange.max,
										sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'unitId',
										sortOrder: backingGrid.currentSortDirection ? backingGrid.currentSortDirection : 'ASC',
										filterField: ElementUtil.query(availableFilterToolbar, 'filterfield').value || 'unitRefNo',
										filterValue: ElementUtil.query(availableFilterToolbar, 'filtervalue').value || ''
									};
									DataManagementService.getUndoService().getAffectedUnits(record.undoId, filter)
											.then(function(records) {
										loadMask.remove();
										var selectedMap = {};
										selectedForRestore.forEach(function(item) {
											selectedMap[item.referenceType + ':' + item.unitId] = true;
										});
										var filtered = [];
										(records.data || []).forEach(function(item) {
											if (!selectedMap[item.referenceType + ':' + item.unitId]) {
												filtered.push(item);
											}
										});
										availableGrid.activeItem = null;
										availableGrid.selectedItems = [];
										availableGrid.items = filtered;
										pagingToolbar.totalRecords = records.totalNumber;
										pagingToolbar.updatePager();
									}, function() {
										loadMask.remove();
									});
								};
							}
						});

						var includeFilterToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'vaadin-text-field',
									itemid: 'filterselected',
									'class': 'spacer-toolbar-item',
									'keep-open': true,
									label: 'Filter Selected',
									listeners: {
										input: {
											fn: function() {
												actionRefreshIncludeGrid();
											},
											buffer: 300
										}
									}
								},
								{
									tag: 'vaadin-button',
									'class': 'spacer-toolbar-item',
									children: [ElementUtil.makeIcon('vaadin:plus', ' Add')],
									listeners: {
										click: function() {
											actionAddUnits(availableGrid.selectedItems || []);
										}
									}
								},
								{
									tag: 'vaadin-button',
									'class': 'spacer-toolbar-item',
									children: [ElementUtil.makeIcon('vaadin:minus', ' Remove')],
									listeners: {
										click: function() {
											actionRemoveUnits(includeGrid.selectedItems || []);
										}
									}
								}
							]
						});

						var includeTitle = ElementUtil.create({
							tag: 'div',
							slot: 'toolbar',
							children: [
								{
									tag: 'dl-section-title',
									title: 'Include in Restore',
									style: 'margin-top: 8px;'
								},
								includeFilterToolbar
							]
						});

						var includeGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'wrap-cell-content row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							'rows-draggable': true,
							'drop-mode': 'on-grid',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true
							},
							children: [
								{
									tag: 'vaadin-grid-selection-column',
									'auto-select': true,
									'auto-width': true
								},
								{
									path: 'referenceType',
									header: 'Type',
									width: '6em'
								},
								{
									path: 'unitRefNo',
									header: 'Unit Ref No',
									width: '9em'
								},
								{
									path: 'unitId',
									header: 'Unit Id',
									width: '9em'
								}
							],
							listeners: {
								'active-item-changed': function(event) {
									const item = event.detail.value;
									includeGrid.selectedItems = item ? [item] : [];
								},
								'grid-dragstart': function(event) {
									includeGrid.draggedItems = event.detail.draggedItems;
								},
								'grid-dragend': function() {
									delete includeGrid.draggedItems;
								},
								'grid-drop': function() {
									const dragged = availableGrid.draggedItems;
									if (!dragged) {
										return;
									}
									actionAddUnits(dragged);
								}
							}
						});

						var splitLayout = ElementUtil.create({
							tag: 'vaadin-split-layout',
							slot: 'primary',
							style: 'height: 100%;',
							children: [
								{
									tag: 'dl-flex-layout',
									children: [
										availableTitle,
										availableGrid,
										availablePagingToolbar
									]
								},
								{
									tag: 'dl-flex-layout',
									children: [
										includeTitle,
										includeGrid
									]
								}
							]
						});

						var unitSelectionPanel = ElementUtil.create({
							tag: 'div',
							itemid: 'unitselectionpanel',
							'class': 'hide',
							style: 'height: ' + unitSelectionMinHeight + '; min-height: 280px;',
							children: [splitLayout]
						});

						var footer = ElementUtil.create({
							tag: 'div',
							style: 'text-align: center;',
							defaults: {
								tag: 'vaadin-button'
							},
							children: [
								{tag: 'hr'},
								{
									theme: 'primary',
									children: [ElementUtil.makeIcon('vaadin:arrow-backward', ' Submit Restore')],
									listeners: {
										click: function() {
											var allUnits = !!ElementUtil.query(optionsToolbar, 'allunits').checked;
											var unitIds = [];
											if (!allUnits) {
												if (selectedForRestore.length === 0) {
													window.DL.MessageUtil.showToast('Validation', 'Select units to restore, or check All units.', {
														theme: 'error'
													});
													return;
												}
												selectedForRestore.forEach(function(item) {
													unitIds.push(item.unitId);
												});
											}
											var loadMask = dialog.showLoading('Submitting restore...');
											var request = {
												manualOnly: !!ElementUtil.query(optionsToolbar, 'manualonly').checked
											};
											if (!allUnits) {
												request.unitIds = unitIds;
											}
											DataManagementService.getUndoService().restoreDeletedData(record.undoId, request)
													.then(function() {
												loadMask.remove();
												dialog.close();
												window.DL.MessageUtil.showToast('Success', 'Partial restore task submitted', {
													theme: 'success'
												});
												actionRefresh();
											}, function() {
												loadMask.remove();
											});
										}
									}
								},
								{
									theme: 'tertiary',
									innerHTML: 'Cancel',
									style: 'margin-left: 10px;',
									listeners: {
										click: function() {
											dialog.close();
										}
									}
								}
							]
						});

						var layout = ElementUtil.create({
							tag: 'div',
							style: 'display: flex; flex-direction: column; gap: 4px;',
							children: [
								info,
								optionsToolbar,
								unitSelectionPanel,
								footer
							]
						});
						dialog.addToContentElement(layout);

						var actionLoadAvailable = function() {
							if (ElementUtil.query(optionsToolbar, 'allunits').checked) {
								return;
							}
							availablePagingToolbar.loadPage(1);
						};

						var actionRefreshIncludeGrid = function() {
							var filterValue = (ElementUtil.query(includeFilterToolbar, 'filterselected').value || '').toLowerCase();
							var rows = [];
							selectedForRestore.forEach(function(item) {
								if (!filterValue
										|| (item.unitRefNo && item.unitRefNo.toLowerCase().includes(filterValue))
										|| (item.unitId && item.unitId.toLowerCase().includes(filterValue))) {
									rows.push(item);
								}
							});
							includeGrid.items = rows;
						};

						var actionAddUnits = function(units) {
							if (!units || units.length === 0) {
								return;
							}
							var existing = {};
							selectedForRestore.forEach(function(item) {
								existing[item.referenceType + ':' + item.unitId] = true;
							});
							units.forEach(function(item) {
								var key = item.referenceType + ':' + item.unitId;
								if (!existing[key]) {
									selectedForRestore.push({
										referenceType: item.referenceType,
										unitId: item.unitId,
										unitRefNo: item.unitRefNo
									});
									existing[key] = true;
								}
							});
							actionRefreshIncludeGrid();
							actionLoadAvailable();
						};

						var actionRemoveUnits = function(units) {
							if (!units || units.length === 0) {
								return;
							}
							var removeMap = {};
							units.forEach(function(item) {
								removeMap[item.referenceType + ':' + item.unitId] = true;
							});
							selectedForRestore = selectedForRestore.filter(function(item) {
								return !removeMap[item.referenceType + ':' + item.unitId];
							});
							actionRefreshIncludeGrid();
							actionLoadAvailable();
						};

						var actionToggleAllUnits = function() {
							var allUnits = !!ElementUtil.query(optionsToolbar, 'allunits').checked;
							if (allUnits) {
								unitSelectionPanel.classList.add('hide');
							} else {
								unitSelectionPanel.classList.remove('hide');
								unitSelectionPanel.style.height = unitSelectionMinHeight;
								unitSelectionPanel.style.minHeight = '280px';
								actionLoadAvailable();
								actionRefreshIncludeGrid();
							}
							dialog.refitToContent();
						};

						actionToggleAllUnits();
					}
				}
			});
		};
		
		var actionDeleteSelected = function() {
			var selected = grid.selectedItems || [];
			if (selected.length === 0) {
				return;
			}
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to permanently delete <b>' + selected.length + '</b> undo record(s)?<br>'
						+ 'This cannot be undone. Soft-deleted operational data (GPS, Fuel, Trip, Idle, Distance) '
						+ 'is hard-purged as a background batch task (data locks ignored). Other undo types are removed immediately.',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Deleting...');
							var undoIds = selectedUndoIds();
							var request = undoIds.length === 1
									? DataManagementService.getUndoService().deleteUndoRecord(undoIds[0])
									: DataManagementService.getUndoService().bulkDelete(undoIds);
							request.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success',
										'Delete submitted for ' + undoIds.length + ' undo record(s). '
										+ 'Operational data hard-purge runs in the background when applicable.', {
									theme: 'success'
								});
								actionRefresh();
							});
						}
					},
					{
						text: 'No'
					}
				]
			});
		};
	
	}
	
}
customElements.define('dl-undo-management-grid', UndoManagementGrid);
